import React, { useCallback, useState } from "react";
import { Button } from "components/bootstrap";
import CollectionModal from "collections/components/CollectionModal";
import useCollectionMutation from "collections/hooks/useCollectionMutation";
import { useTranslation } from "react-i18next";
const UpdateCollectionButton = ({ bsSize = "md", bsStyle = "default", buttonText, editCollection }) => {
  const { t } = useTranslation("enterprise_collections");
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const toggleUpdateModal = useCallback(() => setShowUpdateModal((cur) => !cur), []);
  const { updateCollection } = useCollectionMutation();
  const onUpdate = (values) => updateCollection({
    title: values.title,
    description: values.description,
    id: editCollection.id
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { bsSize, bsStyle, onClick: toggleUpdateModal }, buttonText != null ? buttonText : t("shared.update_collection")), showUpdateModal && /* @__PURE__ */ React.createElement(
    CollectionModal,
    {
      title: t("shared.update_collection"),
      submitButtonText: t("shared.update_collection"),
      submitLoadingText: t("update_collection_button.updating"),
      onSubmit: onUpdate,
      onClose: toggleUpdateModal,
      initialCollection: editCollection
    }
  ));
};
export default UpdateCollectionButton;
